<template>
  <v-container fill-height grid-list-xl>
    <v-layout justify-center wrap>
      <section
        id="headerSection"
        style="position:relative;min-width:100vw;top:-12px;height:500px"
      >
        <v-img
          height="100%"
          position="left center"
          :src="require('../assets/Headers/NEW_Home Image_text-01-01.jpg')"
          class="hidden-xs-only"
        />
        <v-img
          height="300"
          position="left center"
          :src="require('../assets/Headers/NEW_Home Image_text-01-01.jpg')"
          class="hidden-sm-and-up"
        />
      </section>
      <section style="position:relative;min-width:100vw;">
        <v-layout
          row
          wrap
          align-center
          style="padding-left: 15px; padding-right: 15px;"
        >
          <v-flex xm12 sm6 md4 style="text-align: center">
            <h3
              class="counterTextHome"
              style="font-weight: bold !important; font-family: 'Aleo' !important; font-size: 3.0rem !important; color: #58595b;"
            >
              ${{ contributionsCommaCurrent }}
            </h3>
            <h3
              class="counterTextHome"
              style="font-family: 'Aleo' !important; font-size: 1.5rem !important; color: #58595b;margin: auto; max-width: 150px; top: -20px; position: relative;"
            >
              Raised for causes so far
            </h3>
          </v-flex>
          <v-flex xm12 sm6 md4 style="text-align: center">
            <h3
              class="counterTextHome"
              style="font-weight: bold !important; font-family: 'Aleo' !important; font-size: 3.0rem !important; color: #58595b;"
            >
              {{ communityHourCalc }}
            </h3>
            <h3
              class="counterTextHome"
              style="font-family: 'Aleo' !important; font-size: 1.5rem !important; color: #58595b;margin: auto; max-width: 180px; top: -20px; position: relative;"
            >
              Equivalent hours of support
            </h3>
          </v-flex>
          <v-flex xs12 md4 style="text-align: center;">
            <h3
              class="counterTextHome"
              style="font-weight: bold !important; font-family: 'Aleo' !important; font-size: 3.0rem !important; color: #58595b;"
            >
              {{ numberGoodCauses }}
            </h3>
            <h3
              class="counterTextHome"
              style="font-family: 'Aleo' !important; font-size: 1.5rem !important; color: #58595b;margin: auto; max-width: 150px; top: -20px; position: relative;"
            >
              UpstreamNZ Good Causes
            </h3>
          </v-flex>
          <v-flex v-if="typeof fullWidthBanner != 'undefined'" xs12>
            <a
              v-if="fullWidthBanner[0]"
              @click="
                $router.push(`/business/${fullWidthBanner[0].business_id}`)
              "
            >
              <v-img
                v-if="!$vuetify.breakpoint.xs"
                style="cursor: pointer; border-radius: 5px;"
                :src="fullWidthBanner[0].imageUrl"
              />
              <v-img
                v-else
                style="cursor: pointer; border-radius: 5px;"
                :src="fullWidthBanner[0].mobileImageUrl"
              />
            </a>
          </v-flex>
          <v-flex
            v-for="feature in featuredListings"
            :key="feature.imageUrl"
            xs12
            sm4
          >
            <v-card
              v-if="feature.frontPagePosition != 'Banner'"
              tile
              class="elevation-1"
              @click="$router.push(`/business/${feature.business_id}`)"
            >
              <v-img :src="feature.imageUrl" aspect-ratio="2" />
            </v-card>
          </v-flex>
        </v-layout>
      </section>

      <section style="position:relative;min-width:100vw;margin-top:30px;">
        <div grid-list-xl class="pageContent">
          <div class="browseBarWrap" id="browseTitleWrap">
            <v-layout row wrap>
              <div class="browseBarContainer">
                <h1 style="display: inline-block;">Browse by Category</h1>
              </div>
            </v-layout>
          </div>
          <v-layout
            row
            wrap
            align-center
            style="width: 100vw;margin: auto; margin-top: -1px;"
          >
            <!-- <v-flex v-for="category in categoriesByName" :key="category.id" xs12 sm4>
              <v-card @click="$router.push(`/searchResults/category/${category.name}`)">
                <v-img :src="category.imageUrl" height="150px" />
                <v-card-actions>
                  <span class="title" v-text="category.name"></span>
                </v-card-actions>
              </v-card>
            </v-flex>-->
            <v-flex
              xs12
              sm4
              class="categoryCardsHome"
              style="padding: 0px 13px 12px 0px;"
            >
              <v-card @click="$router.push('/searchResults/category/1')">
                <v-img
                  :src="require('../assets/Home/business-services-01.jpg')"
                  style="border-radius: 0px; "
                />
              </v-card>
            </v-flex>
            <v-flex
              xs12
              sm4
              class="categoryCardsHome"
              style="padding: 0px 7px 12px"
            >
              <v-card @click="$router.push('/searchResults/category/2')">
                <v-img
                  :src="
                    require('../assets/Home/events-and-entertainment-02.jpg')
                  "
                  style="border-radius: 0px; "
                />
              </v-card>
            </v-flex>
            <v-flex
              xs12
              sm4
              class="categoryCardsHome"
              style="padding: 0px 0px 12px 13px;"
            >
              <v-card @click="$router.push('/searchResults/category/5')">
                <v-img
                  :src="require('../assets/Home/trades-03.jpg')"
                  style="border-radius: 0px; "
                />
              </v-card>
            </v-flex>
            <v-flex
              xs12
              sm4
              class="categoryCardsHome"
              style="padding: 12px 12px 12px 0px; "
            >
              <v-card @click="$router.push('/searchResults/category/1')">
                <v-img
                  :src="require('../assets/Home/homes-services-04.jpg')"
                  style="border-radius: 0px; "
                />
              </v-card>
            </v-flex>
            <v-flex
              xs12
              sm4
              class="categoryCardsHome"
              style="padding: 12px 7px; "
            >
              <v-card @click="$router.push('/searchResults/category/3')">
                <v-img
                  :src="require('../assets/Home/professional-services-05.jpg')"
                  style="border-radius: 0px; "
                />
              </v-card>
            </v-flex>
            <v-flex
              xs12
              sm4
              class="categoryCardsHome"
              style="padding: 12px 0px 12px 12px; "
            >
              <v-card @click="$router.push('/searchResults/category/4')">
                <v-img
                  :src="require('../assets/Home/retail-06.jpg')"
                  style="border-radius: 0px; "
                />
              </v-card>
            </v-flex>
          </v-layout>
        </div>
      </section>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    menuProps: {
      openOnClick: false,
    },
    communityHours: 0,
    items: [
      {
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F1_resized.jpg?alt=media&token=0f475253-a02b-4ae2-ac0c-e5d0761291b0",
      },
      {
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F2_resized.jpg?alt=media&token=f901d032-bd8a-4463-9678-f448419c3339",
      },
      {
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F3_resized.jpg?alt=media&token=f42656ea-0c3e-482d-b37d-6532c5d92548",
      },
      {
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F4_resized.jpg?alt=media&token=ab1040be-cb40-45a2-a165-867782b0ea61",
      },
      {
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F6_resized.jpg?alt=media&token=14050181-b066-4f91-90c3-57afa9cb2dd0",
      },
      {
        src:
          "https://firebasestorage.googleapis.com/v0/b/upstream-nz.appspot.com/o/backgroundImages%2F7_resized.jpg?alt=media&token=7a372f29-a81c-4483-bb0d-b017fe3af8f8",
      },
    ],
    formData: {},
  }),
  computed: {
    ...mapGetters({
      user: "user",
      services: "business/services",
      featuredListings: "featuredListings/listHomePage",
      fullWidthBanner: "featuredListings/fullWidthBanner",
      categories: "categories/list",
      categoriesByName: "categories/byName",
      contributions: "general/contributions",
      goodCauses: "goodCauses/approved",
    }),
    communityHourCalc: function() {
      let hours = this.contributions.current * 0.0567;
      hours = Math.round(hours);
      if (hours > this.communityHours) {
        return hours;
      } else {
        return this.communityHours;
      }
    },
    contributionsCommaCurrent: function() {
      if (this.contributions.current != null) {
        return this.contributions.current
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    numberGoodCauses: function() {
      return this.goodCauses.length;
    },
  },
  mounted() {
    this.$store.dispatch("featuredListings/loadAll");
    this.$store.dispatch("general/loadAll");
  },
};
</script>

<style>
.application {
  background-color: white !important;
}

.browseBarWrap {
  position: relative;
  background: #4cc7e8;
  width: 100vw;
  top: 0px;
  height: 100px;
}

.browseBarContainer {
  position: relative;
  margin: auto;
  text-align: center;
  margin-top: 8px;
  /* max-width: 75%; */
}

.browseBarContainer h1 {
  font-weight: bold !important;
  font-family: "Aleo" !important;
  font-size: 30pt !important;
  color: white;
}

.searchOverlay {
  position: absolute;
  top: 0px;
  font-weight: bold;
  font-family: "Aleo";
  font-size: 22pt;
  text-align: center;
  color: white;
  left: inherit;
  width: 100%;
  /*background: rgba(56, 240, 255, 0.65);*/
  padding: 15px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.headline {
  font-family: "Aleo" !important;
}

@media only screen and (max-width: 1000px) {
  .counterTextHome {
    font-size: 20pt !important;
  }
}

@media only screen and (max-width: 632px) {
  .browseBarContainer h1 {
    font-size: 27pt;
  }
}

@media only screen and (max-width: 600px) {
  section#headerSection {
    height: 300px !important;
  }
}

@media only screen and (max-width: 600px) {
  section#headerSection {
    height: 300px !important;
  }
  .categoryCardsHome {
    padding: 0 0 14px 0 !important;
  }
  .browseBarContainer h1 {
    font-size: 2rem !important;
  }
}

@media only screen and (min-width: 600px) {
  .searchOverlay {
    font-size: 28pt;
    width: 600px;
    left: calc(50% - 300px);
  }
}

@media only screen and (min-width: 1904px) {
  .pageContent {
    max-width: 1200px;
  }
}

.display-3 {
  font-family: "Aleo" !important;
}
</style>
